import React, {useEffect, useState} from "react";
import Page from "../Components/Page";
import {getRetailerMapUseGetRetailerLookupInstead} from "../../utils/localCache/retailerMapCache";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import {salesforceRetailersQuery} from "../../queries/salesforceRetailersQuery";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import ReactTable from "../Components/ReactTable";
import {Breadcrumbs} from "../Components/Breadcrumbs";


function MissingRetailers() {

    const [loading, setLoading] = useState(true);
    const [missingRetailers, setMissingRetailers] = useState([]);

    const getMissingRetailerIds = (retailerIds, retailerIdsToFilterOut, status) => retailerIds
        .filter(retailerId => !retailerIdsToFilterOut.includes(retailerId))
        .map(retailerId => {
            return {"retailerId": retailerId, "status": status}
        });

    useEffect(() => {
        setLoading(true)
        const nucleusRetailerIds = Object.keys(getRetailerMapUseGetRetailerLookupInstead()).map(retailerId => parseInt(retailerId));
        makeApolloClientCall(salesforceRetailersQuery, false)
            .then((response) => {
                const salesforceRetailerIds = response['salesforceRetailers'].map(retailerIdObject => retailerIdObject['retailerId']);
                const salesforceOnlyRetailers = getMissingRetailerIds(salesforceRetailerIds, nucleusRetailerIds, "Salesforce Only");
                const nucleusOnlyRetailers = getMissingRetailerIds(nucleusRetailerIds, salesforceRetailerIds, "Nucleus Only");
                const missingRetailers = salesforceOnlyRetailers.concat(nucleusOnlyRetailers)
                    .sort((a, b) => {
                        if (a["retailerId"] > b["retailerId"]) {
                            return 1;
                        }
                        if (a["retailerId"] < b["retailerId"]) {
                            return -1;
                        }
                        return 0;
                    });
                setLoading(false);
                setMissingRetailers(missingRetailers);
            })
            .catch((error) => {
                console.error(error)
                setLoading(false);
            })
            .finally(() => setLoading(false));
    }, [])


    const customColumns = [
        {
            header: "Retailer Id", accessorKey: "retailerId", enableGlobalFilter: true
        },
        {header: "Status", accessorKey: "status",}
    ];

    return (
        <Page name={"Missing Retailers"}
              breadCrumbs={<Breadcrumbs
                  items={[{label: "Management"}, {label: "Retailers"}, {label: "Missing Retailers"}]}/>}
        >
            <LoadingWrapper loading={loading}>
                <ReactTable
                    data={missingRetailers}
                    filterable
                    schema={{"fields": [{"name": "retailerId", "type": "integer"}]}}
                    columns={customColumns}
                    initialState={{pagination: {pageSize: 10}}}
                />
            </LoadingWrapper>
        </Page>
    )
}

export default MissingRetailers
